import React from 'react'
import PropTypes from 'prop-types'
import BrowserNotification from 'views/components/presentationals/Notification'

class Notification extends React.PureComponent {
  static propTypes = {
    unreadMessages: PropTypes.array.isRequired,
    notify: PropTypes.func.isRequired,
  }

  onclick = function(event, delivery) {
    event.preventDefault()
    window.open(`${window.location.origin}/delivery/${delivery}/messaging`, '_glinko')
  }
  render = () => {
    const { unreadMessages, notify } = this.props
    const logo = require('assets/img/app_logo.png')
    let unreadMessage = unreadMessages.find((unread) => unread.notified === false)
    return (
      <div>
        {unreadMessage && (
          <BrowserNotification
            title={`GLINKO | Course ${unreadMessage.delivery.name} | ${unreadMessage.author.firstname} ${unreadMessage.author.lastname}`}
            unreadMessage={unreadMessage}
            onShow={() => {
              notify(unreadMessage)
            }}
            onClick={(e, tag) => {
              this.onclick(e, unreadMessage.delivery.id)
            }}
            options={{
              tag: `GL-UR-${unreadMessage.id}`,
              body: unreadMessage.message,
              icon: `${window.location.origin}${logo}`,
            }}
          />
        )}
      </div>
    )
  }
}

export default Notification
